import axios from "axios";

const notificationAPI = axios.create({
  baseURL: "https://missionmap-lc.onrender.com/api", // 👈 only /api
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach token if you use JWT
notificationAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default notificationAPI;
